import axios from "axios";
import GetServerAddress from "../../../../functions/GetServerAddress";

export async function Get_Null_School_Or_Country_Attendees(
  dbName,
  collctiontext,
  setdata,
  limit,
  SetHowMany,
  Type,
  skip,
  logout
) {
  try {
    const response = await axios.post(
      GetServerAddress() + "api/staff/Get_Null_School_Or_Country_Attendees",
      {
        dbName: dbName,
        collctiontext: collctiontext,
        limit: limit,
        Type: Type,
        skip: skip,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
          username: localStorage.getItem("Username"),
          activitylog: "No",
        },
      }
    );
    // Check for specific server response indicating an invalid auth token
    if (response.data.status === 403 || response.data.status === 401) {
      logout();
      return; // Stop further execution in case of invalid auth token
    }
    console.log("Response Data: ", response);
    if (SetHowMany === "All") {
      setdata(response.data.data);
    } else {
      setdata(response.data.data[0]);
    } // Update your state with the fetched data
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}
